import { formatDate } from "@ui-seeker/utils"


export default function endDateColumn() {
    return {
        name: "endDate", label: "End Date",
        options: {
            filter: false,
            customBodyRowRender: value => value ? formatDate(value, { isString: true }) : "--",
        }
    }
}